import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  changelogContainer: {
    height: "100%",
    backgroundColor: "#fafafa",
    maxWidth: "100%",
  },
  changelogHeader: {
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #e0e0e0",
    padding: "0 0 16px 0",
    marginBottom: "20px",
    top: 0,
    zIndex: 10,
  },
  changelogTitle: {
    fontSize: "1.8rem",
    fontWeight: "bold",
    marginBottom: "8px",
    color: "#22223B",
    borderBottom: "3px solid #168AAD",
    paddingBottom: "12px",
  },
  changelogSubtitle: {
    fontSize: "1rem",
    color: "#666",
    fontWeight: 400,
    margin: "8px 0 0 0",
  },
  versionCard: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "24px",
    marginBottom: "20px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    border: "1px solid #e0e0e0",
  },
  versionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "12px",
  },
  versionNumber: {
    fontSize: "1.4rem",
    fontWeight: "bold",
    color: "#168AAD",
  },
  versionDate: {
    fontSize: "0.9rem",
    color: "#666",
    backgroundColor: "#f5f5f5",
    padding: "4px 12px",
    borderRadius: "12px",
  },
  versionBadge: {
    marginLeft: "12px",
    padding: "4px 12px",
    borderRadius: "12px",
    fontSize: "0.8rem",
    fontWeight: "bold",
    textTransform: "uppercase" as const,
    "&.major": {
      backgroundColor: "#ff4444",
      color: "white",
    },
    "&.minor": {
      backgroundColor: "#168AAD",
      color: "white",
    },
    "&.patch": {
      backgroundColor: "#4caf50",
      color: "white",
    },
    "&.breaking": {
      backgroundColor: "#ff9800",
      color: "white",
    },
  },
  versionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    margin: "12px 0",
    color: "#22223B",
  },
  versionDescription: {
    fontSize: "1.1rem",
    color: "#555",
    marginBottom: "24px",
    lineHeight: "1.6",
  },
  changeSection: {
    marginBottom: "20px",
    padding: "16px",
    borderRadius: "6px",
    border: "1px solid #e8e8e8",
  },
  changeTypeHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "12px",
  },
  changeTypeIcon: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    marginRight: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "bold",
    color: "white",
    "&.added": {
      backgroundColor: "#4caf50",
    },
    "&.changed": {
      backgroundColor: "#168AAD",
    },
    "&.deprecated": {
      backgroundColor: "#ff9800",
    },
    "&.removed": {
      backgroundColor: "#f44336",
    },
    "&.fixed": {
      backgroundColor: "#9c27b0",
    },
    "&.security": {
      backgroundColor: "#e91e63",
    },
  },
  changeTypeTitle: {
    fontSize: "1.1rem",
    fontWeight: 600,
    textTransform: "capitalize" as const,
    color: "#333",
  },
  changeCategory: {
    fontSize: "0.85rem",
    color: "#666",
    fontWeight: 500,
    backgroundColor: "#f0f0f0",
    padding: "2px 8px",
    borderRadius: "10px",
    marginLeft: "8px",
  },
  changeDescription: {
    fontSize: "1rem",
    color: "#444",
    marginBottom: "12px",
    lineHeight: "1.5",
  },
  changeDetails: {
    marginLeft: "0",
    paddingLeft: "0",
    "& li": {
      listStyle: "none",
      position: "relative",
      paddingLeft: "20px",
      marginBottom: "6px",
      color: "#555",
      "&::before": {
        content: '"•"',
        position: "absolute",
        left: "0",
        color: "#168AAD",
        fontWeight: "bold",
      },
    },
  },
  endpointsList: {
    marginTop: "16px",
    padding: "16px",
    backgroundColor: "#f8f9fa",
    borderRadius: "6px",
    border: "1px solid #e9ecef",
  },
  endpoint: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
    "&:last-child": {
      marginBottom: "0",
    },
  },
  httpMethod: {
    padding: "4px 12px",
    borderRadius: "4px",
    fontSize: "0.75rem",
    fontWeight: "bold",
    marginRight: "12px",
    minWidth: "50px",
    textAlign: "center",
    "&.GET": {
      backgroundColor: "#4caf50",
      color: "white",
    },
    "&.POST": {
      backgroundColor: "#2196f3",
      color: "white",
    },
    "&.PUT": {
      backgroundColor: "#ff9800",
      color: "white",
    },
    "&.PATCH": {
      backgroundColor: "#9c27b0",
      color: "white",
    },
    "&.DELETE": {
      backgroundColor: "#f44336",
      color: "white",
    },
  },
  endpointPath: {
    fontFamily: "monospace",
    fontSize: "0.9rem",
    color: "#333",
    backgroundColor: "white",
    padding: "4px 8px",
    borderRadius: "4px",
    border: "1px solid #ddd",
  },
  migrationSection: {
    marginTop: "20px",
    padding: "20px",
    backgroundColor: "#fff3cd",
    border: "1px solid #ffeaa7",
    borderRadius: "8px",
  },
  migrationTitle: {
    fontSize: "1.1rem",
    fontWeight: "bold",
    color: "#856404",
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    "&::before": {
      content: '"⚠"',
      marginRight: "10px",
      fontSize: "1.3rem",
    },
  },
  migrationSteps: {
    marginLeft: "0",
    paddingLeft: "20px",
    "& li": {
      marginBottom: "6px",
      color: "#856404",
    },
  },
  codeExample: {
    marginTop: "16px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
  },
  codeBlock: {
    backgroundColor: "#f8f9fa",
    border: "1px solid #e9ecef",
    borderRadius: "6px",
    padding: "16px",
    fontFamily: "monospace",
    fontSize: "0.9rem",
    overflow: "auto",
    maxHeight: "300px",
  },
  codeHeader: {
    fontSize: "0.8rem",
    fontWeight: "bold",
    color: "#666",
    marginBottom: "8px",
    textTransform: "uppercase" as const,
  },
}));
